import gumbenzoin1 from "../assets/gum-benzoin-1.jpeg"
import gumbenzoin2 from "../assets/gum-benzoin-2.jpeg"



const CopalData = [
    {
        imgsrc: gumbenzoin1, 
        title: "Gum Benzoin Julur Quality",
        text: "Gum Benzoin Julur Quality is a variation of Gum Benzoin. This variant has the same size as the Tahir variant, which is 5 to 7 cm. However, this variant is darker in color than the Tahir variant."
    },
    {
        imgsrc: gumbenzoin2, 
        title: "Gum Benzoin Tahir Quality",
        text: "Gum Benzoin Tahir Quality is a variation of Gum Benzoin. As for the texture itself, the Tahir variant measures 5 to 7 cm. Also, the Tahir variant has brighter colors."
    }
]

export default CopalData;





